import * as React from "react";
import { isRedesignEnabled } from "./flag";

/**
 * Route wrapper for marketing pages.
 *
 * Legacy pages render inside a `<Navigation />` + `<Footer />` chrome at the
 * App level. Redesign pages provide their own `MarketingLayout` (with its own
 * topbar + footer), so when the flag is on we bypass the legacy chrome.
 *
 * Usage:
 *   <MarketingRoute legacy={<><Navigation /><Pricing /><Footer /></>} redesign={<PricingRedesign />} />
 */
export function MarketingRoute({
  legacy,
  redesign,
}: {
  legacy: React.ReactElement;
  redesign: React.ReactElement;
}) {
  return isRedesignEnabled() ? redesign : legacy;
}
